import NoResultsModule from './no-results.module'

export default NoResultsModule
